import * as React from "react";
import { Link, LinkContainer } from "components/common";
import ReportRoutes from "report/ReportRoutes";
import { Button } from "components/bootstrap";
import StatusCell from "report/report-history-page/StatusCell";
const customColumnRenderers = (pluggableColumnRenderers) => ({
  attributes: {
    title: {
      renderCell: (title, report) => /* @__PURE__ */ React.createElement(Link, { to: ReportRoutes.archive(report.id) }, title),
      width: 0.7
    },
    subtitle: {
      width: 0.7
    },
    timezone: {
      width: 0.3
    },
    status: {
      renderCell: (_, report) => report.status ? /* @__PURE__ */ React.createElement(StatusCell, { value: report.status }) : null,
      staticWidth: 120
    },
    recipients: {
      renderCell: (_, report) => /* @__PURE__ */ React.createElement(LinkContainer, { key: "configuration-button", to: ReportRoutes.EDIT.delivery(report.id) }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall" }, report.delivery.email_receivers.length + report.delivery.user_receivers.length === 0 ? "+ Add Emails" : report.delivery.email_receivers.length + report.delivery.user_receivers.length)),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    ...pluggableColumnRenderers || {}
  }
});
export default customColumnRenderers;
